import { Pipe, PipeTransform } from '@angular/core';
import { Trace } from '../models/tracer.model';

@Pipe({
  name: 'getTraceBorderColor',
})
export class GetTraceBorderColorPipe implements PipeTransform {
  transform(trace: Trace, allTraces: Trace[]): string {
    const matchingTraces = allTraces.filter(
      (item) => item.Providers === trace.Providers && item.Source === trace.Source,
    );

    if (matchingTraces.every((t) => t.Status === 'error')) {
      return 'border-red-600';
    } else if (matchingTraces.some((t) => t.Status === 'error')) {
      return 'border-yellow-400';
    } else {
      return 'border-gray-200';
    }
  }
}
